/* eslint-disable */
export default {
  _car_crash: 'car_crash',
  _crash: 'crash',
  _win_level: 'win_level',
  _card_fall: 'card_fall',
  _cartoon_win_1: 'cartoon_win_1',
  _car_horn: 'car_horn',
  _car_rev_01: 'car_rev_01',
  _game_over_funny: 'game_over_funny',
  _fast_woosh_4: 'fast_woosh_4',
  _car_rev: 'car_rev',
  _tire_skid_squeal08: 'tire_skid_squeal08',
  _card_placed: 'card_placed',
  _pass: 'pass',
  _click: 'click',
  _engine_stop: 'engine_stop',
  _engine_start: 'engine_start',
}